import axios from 'axios'
import {configSSO} from '../../assets/js/config.js'
import T2Auth from '../../assets/js/t2Auth.js'
import { MessageBox } from 'element-ui'
import { HTTPResponseCodes } from './Enum/ResponseCodes/HTTPResponseCodes'
import Cookie from 'js-cookie'
import Recaptcha from './Recaptcha'
import kriticniEndpointi from './Enum/KriticniEndpointi'

function ClientAgent () {
  this.t2Auth = T2Auth.getInstance()
  this.wsTimeout = process.env.DEFAULT_TIMEOUT
  this.cancelConsecutiveRequests = false
  this.t2Auth.handleAuthentication(this)
  this.kriticniEndpointi = kriticniEndpointi
}
ClientAgent.prototype.initGUILayout = function () {
  this.t2Auth.initGUI()
}
ClientAgent.prototype.getAccessToken = function () {
  let accessToken = Cookie.get(configSSO.ACCESS_TOKEN_NAME)
  if (accessToken === null || accessToken === undefined) {
    this.t2Auth.login()
    return false
  }
  return accessToken
}
ClientAgent.prototype.prolongToken = function () {
  this.getAccessToken()
  let expirationDate = new Date(Cookie.get(configSSO.ACCESS_TOKEN_EXPIRES_AT))
  let currentDate = new Date()
  let expirationInMinutes = (expirationDate.getTime() - currentDate.getTime()) / 60000
  if (expirationInMinutes < 5) {
    this.t2Auth.refreshToken()
  }
}
ClientAgent.prototype.postWsRequest = function (vmesnik, pot, param, prenosniParametri, successCallbackName,
  errCallbackName, customTimeout = 0, zadnjaIteracija = false, recaptchaVerzija = 3) {
  // zadnji znak v osnovnem delu poti mora biti '?'
  if (pot.slice(-1) !== '?') {
    pot += '?'
  }
  this.checkKriticniProces(pot, recaptchaVerzija, (jeKriticen, recaptchaVerzija, recaptchaToken) => {
    if (jeKriticen) {
      for (let i = (param.length - 1); i >= 0; i--) {
        if (param[i].startsWith('recaptchaVersion=') || param[i].startsWith('recaptchaResponse=')) {
          param.splice(i, 1)
        }
      }
      param.push('recaptchaVersion=' + recaptchaVerzija)
      param.push('recaptchaResponse=' + recaptchaToken)
    }
    let accessToken = this.getAccessToken()
    let t2Auth = this.t2Auth
    axios({
      method: 'POST',
      'url': process.env.WS_URL + pot,
      'data': param.join('&'),
      timeout: (customTimeout === 0) ? this.wsTimeout : customTimeout,
      headers: {
        Authorization: 'Bearer ' + accessToken
      }
    }).then(result => { // vse 2xx statusCode
      let status = result.data.status
      if (status === 1) {
        vmesnik[successCallbackName](result.data, prenosniParametri)
      } else if (status === 0) {
        if (result.data.statusCode === HTTPResponseCodes.UNAUTHORIZED) {
          t2Auth.login()
        } else {
          vmesnik[errCallbackName](result.data, prenosniParametri)
        }
      }
    }).catch(err => {
      if (err.response) {
        let podatki = err.response.data
        if (err.code === 'ECONNABORTED' && !zadnjaIteracija) {
          this.postWsRequest(vmesnik, pot, param, prenosniParametri, successCallbackName, errCallbackName,
            customTimeout, true)
        } else if (podatki.statusCode === HTTPResponseCodes.UNAUTHORIZED) {
          t2Auth.login()
        } else if (podatki.statusCode === HTTPResponseCodes.FORBIDDEN && jeKriticen && !zadnjaIteracija) {
          this.postWsRequest(vmesnik, pot, param, prenosniParametri, successCallbackName, errCallbackName,
            customTimeout, true, 2)
        } else if (typeof vmesnik[errCallbackName] === 'function') {
          vmesnik[errCallbackName](podatki, prenosniParametri)
        } else {
          Napaka('Ups, prišlo je do nepričakovane napake.',
            'Izbrane storitve trenutno ni mogoče izvesti.')
        }
      } else {
        console.error(err)
        Napaka('Prišlo je do napake', 'Prosimo poskusite kasneje' + err)
      }
    })
    this.prolongToken()
  })
}

ClientAgent.prototype.postNovice = function (vmesnik, pot, param, prenosniParametri, successCallbackName, errCallbackName) {
  axios({
    method: 'POST',
    responseType: 'json',
    'url': process.env.WS_URL_NOVICE
  }).then(result => {
    vmesnik[successCallbackName](result.data)
  }).catch(err => {
    if (typeof vmesnik[errCallbackName] === 'function') {
      vmesnik[errCallbackName](err)
    }
  })
}

function Napaka (naslov, sporocilo) {
  MessageBox({
    title: naslov,
    message: sporocilo,
    customClass: 'nepricakovane-napake-opozorilo',
    confirmButtonText: 'Zapri',
    confirmButtonClass: 'zapri-gumb',
    showConfirmButtonButton: true
  })
}

ClientAgent.prototype.postPromise = function (pot, param = [], recaptchaVerzija) {
  return new Promise((resolve, reject) => {
    // zadnji znak v osnovnem delu poti mora biti '?'
    if (pot.slice(-1) !== '?') {
      pot += '?'
    }
    let accessToken = this.getAccessToken()
    let t2Auth = this.t2Auth
    this.checkKriticniProces(pot, recaptchaVerzija, (jeKriticen, recaptchaVerzija, recaptchaToken) => {
      if (jeKriticen) {
        for (let i = (param.length - 1); i >= 0; i--) {
          if (param[i].startsWith('recaptchaVersion=') || param[i].startsWith('recaptchaResponse=')) {
            param.splice(i, 1)
          }
        }
        param.push('recaptchaVersion=' + recaptchaVerzija)
        param.push('recaptchaResponse=' + recaptchaToken)
      }
      axios({
        method: 'POST',
        'url': process.env.WS_URL + pot,
        'data': param.join('&'),
        timeout: this.wsTimeout,
        headers: {
          Authorization: 'Bearer ' + accessToken
        }
      }).then(result => { // vse 2xx statusCode
        let status = result.data.status
        if (status === 1) {
          resolve(result.data)
        } else {
          reject(result.message)
        }
      }).catch(async err => {
        if (err.response.status === HTTPResponseCodes.UNAUTHORIZED) {
          t2Auth.login()
        } else if (err.response.status === HTTPResponseCodes.FORBIDDEN && jeKriticen && recaptchaVerzija !== 2) {
          try {
            let result = await this.postPromise(pot, param, 2)
            resolve(result)
          } catch (e) {
            reject(e)
          }
        } else {
          reject(err)
        }
      })
    })
  })
}

ClientAgent.prototype.makeRequest = async function (pot, param, method = 'POST', recaptchaVerzija = 3, customTimeout = 0) {
  let promise = new Promise((resolve, reject) => {
    if (pot.slice(-1) !== '?') {
      pot += '?'
    }
    let accessToken = this.getAccessToken()
    let t2Auth = this.t2Auth
    this.checkKriticniProces(pot, recaptchaVerzija, (jeKriticen, recaptchaVerzija, recaptchaToken) => {
      if (jeKriticen) {
        param.recaptchaVersion = recaptchaVerzija
        param.recaptchaResponse = recaptchaToken
      }
      let axiosConfig = {
        method: method,
        url: process.env.WS_URL + pot,
        timeout: (customTimeout === 0) ? this.wsTimeout : customTimeout,
        headers: {
          Authorization: 'Bearer ' + accessToken,
          'Content-Type': 'application/x-www-form-urlencoded'
        }
      }
      if (method === 'POST') {
        axiosConfig.data = param
      } else {
        axiosConfig.params = param
      }
      axios(axiosConfig).then(result => { // vse 2xx statusCode
        let status = result.data.status
        if (status === 1) {
          resolve(result.data)
        } else {
          reject(result.message)
        }
      }).catch(async err => {
        if (err.response.status === HTTPResponseCodes.UNAUTHORIZED) {
          t2Auth.login()
        } else if (err.response.status === HTTPResponseCodes.FORBIDDEN && jeKriticen && recaptchaVerzija !== 2) {
          try {
            let result = await this.makeRequest(pot, param, method, 2)
            resolve(result)
          } catch (e) {
            reject(e)
          }
        } else {
          reject(err)
        }
      })
    })
  })
  let response = await promise.catch((response) => {
    let errMsg = 'Prišlo je do neznane napake.'
    if (typeof response !== 'undefined' && typeof response.message !== 'undefined') {
      errMsg = response.message
    }
    if (typeof response !== 'undefined' &&
      typeof response.response !== 'undefined' &&
      typeof response.response.data !== 'undefined' &&
      typeof response.response.data.message !== 'undefined') {
      errMsg = response.response.data.message
    }
    throw new Error(errMsg)
  })
  return response
}

ClientAgent.prototype.checkKriticniProces = function (pot, verzija, kriticniProcesiCallback) {
  let kriticniProces = false
  for (let i = 0; i < this.kriticniEndpointi.length; i++) {
    if (this.kriticniEndpointi[i].pot === pot) {
      kriticniProces = true
      break
    }
  }
  if (kriticniProces) {
    try {
      Recaptcha.getInstance().getRecaptchaToken(verzija).then((token) => {
        kriticniProcesiCallback(true, verzija, token)
      })
    } catch (e) {
      console.log(JSON.parse(e))
    }
  } else {
    kriticniProcesiCallback(false)
  }
}

export default ClientAgent



// WEBPACK FOOTER //
// ./src/assets/js/clientAgent.js